import { EarthRemoveIcon } from './EarthRemoveIcon';

/**
 * author: Muhammet Balsoy
 * id 75FA6A35-88AE-4790-9B1A-0D0FD453E472
 * name earth-remove
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/earth-remove.svg
 * tags
 * - Navigation 
 */
export const GlobeRemoveIcon = EarthRemoveIcon;
export default GlobeRemoveIcon